import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loader from "../components/common/Loader";
import NotFoundPage from "../pages/static/NotFoundPage";
import {
  includeAdminRoutes,
  includePublicRoutes,
  isAdminSurface,
} from "../config/env";
import publicRouteElements from "./PublicRouteTree";
import adminRouteElements from "./AdminRouteTree";

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {includePublicRoutes ? publicRouteElements() : null}
        {includeAdminRoutes ? adminRouteElements() : null}
        <Route
          path="*"
          element={
            isAdminSurface ? (
              <Navigate to="/admin" replace />
            ) : (
              <NotFoundPage />
            )
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
